import { render, staticRenderFns } from "./imgItem.vue?vue&type=template&id=16e6db8a&scoped=true&"
import script from "./imgItem.vue?vue&type=script&lang=js&"
export * from "./imgItem.vue?vue&type=script&lang=js&"
import style0 from "./imgItem.vue?vue&type=style&index=0&id=16e6db8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e6db8a",
  null
  
)

export default component.exports